<template>
  <h3 class="text-lg font-semibold leading-6 text-gray-900">
    <slot />
  </h3>
</template>
